import { type FC } from 'react';

interface HeaderLabel {
  width: number;
  title: string;
}

interface HeaderProps {
  labels: Array<HeaderLabel>;
}

const Header: FC<HeaderProps> = ({ labels }) => {
  return (
    <div className="flex flex-row pa3 bg-light-gray br--top br1">
      {labels.map(({ width, title }) => (
        <div key={title} className="near-black fw5 mr5" style={{ width: width || 'auto' }}>
          {title}
        </div>
      ))}
    </div>
  );
};

export default Header;
